import { IsItem } from '../../interfaces/IsItem'

const DeviceStatus: IsItem[] = [
  { id: '1', label: 'نامشخص', value: '1' },
  { id: '2', label: 'متصل', value: '2' },
  { id: '4', label: 'غیرمتصل', value: '4' }
]

export default DeviceStatus
